import React, { useState, useEffect } from "react";
import useStyles from "./styles";
import { Button } from "@material-ui/core";
import AddEditDetails from "./addEditDetails/AddEditDetails";

function DetailPage({ programData, ...props }) {

    const [isContent, setIsContent] = useState(false);
    const [addDetail, setAddDetails] = useState(false);
    const classes = useStyles();

    const editDetails = () => {
        setAddDetails(true)
    }

    const addDetails = () => {
        setAddDetails(true)
    }
    const closeEditDetails = () => {
        setAddDetails(false)
    }

    const Rule = ({ color }) => (
        <hr
            style={{
                borderColor: color,
            }}
        />
    );


    useEffect(() => {
    }, [])

    return (
        <>

            <h3 style={{
                fontFamily: "Lato",
                fontSize: "20px",
                fontWeight: 700,
                margin: "10px 0px"
            }}>Program Name: {programData?.name}</h3>

            <Rule color={"#FFFFFF"} />

            <div dangerouslySetInnerHTML={{ __html: programData?.longDescription || "" }} className={classes.longDesc}>

            </div>

            {addDetail ?
                <AddEditDetails dialogOpenClose={addDetails} handleClose={closeEditDetails}></AddEditDetails>
                : ''
            }

        </>
    )
}
export default DetailPage;